export enum PyramidsViewPermissions {
  editForecast = 'editForecast',
}
